import {
  IconBox,
  IconBrush,
  IconCamera,
  IconLayersIntersect,
  IconLayoutBoardSplit,
  IconLayoutGrid,
  IconToolsKitchen2,
} from '@tabler/icons-react';
import type React from 'react';
import type { ImagePromptCategory } from '@/lib/image-prompts';

export type CategoryIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const CATEGORY_ICONS: Record<ImagePromptCategory, CategoryIcon> = {
  all: IconLayersIntersect,
  'food-drink': IconToolsKitchen2,
  'illustration-3d': IconBrush,
  photography: IconCamera,
  'poster-design': IconLayoutBoardSplit,
  'product-brand': IconBox,
  'ui-graphic': IconLayoutGrid,
};

export function getCategoryIcon(slug: string): CategoryIcon {
  return (
    (CATEGORY_ICONS as Record<string, CategoryIcon>)[slug] ??
    IconLayersIntersect
  );
}
